<div class="column-selector">
  <mat-form-field appearance="fill" class="column-selector__select">
    <mat-select
      [formControl]="control"
      panelClass="column-selector__menu"
      disableOptionCentering
    >
      <mat-option style="border-bottom: 1px solid var(--color-gray-5)"
        >Select Column</mat-option
      >
      <mat-option
        *ngFor="let item of selectedColumnMap"
        [value]="item.name"
        [hidden]="item.columnIndex !== null"
      >
        {{ item.name }}
      </mat-option>
    </mat-select>
  </mat-form-field>
</div>
